const path = '/custom-styles/a-styles.css';
let fileConnected = true;
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = path;
document.head.appendChild(link);

const button = document.createElement('button');
button.classList.add('button-dev');
button.addEventListener('click', (e) => {
  e.preventDefault();
  if (fileConnected) {
    link.href = '';
  } else {
    link.href = path;
  }
  fileConnected = !fileConnected;
  button.classList.toggle('button-dev--off');
});
document.body.appendChild(button);

const style = document.createElement('style');
style.innerHTML = `
  .button-dev {
    position: fixed;
    z-index: 100;
    right: 16px;
    bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    border: none;
    background-color: #fff;
    box-shadow: 0 0 10px #0000001a;
  }

  .button-dev::after {
    content: '';
    width: 18px;
    height: 18px;
    background-image: url(data:image/svg+xml;base64,PCEtLSBpY29uNjY2LmNvbSAtIE1JTExJT05TIE9GIEZSRUUgVkVDVE9SIElDT05TIC0tPjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ2OS4zMzMgNDY5LjMzMyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDY5LjMzMyA0NjkuMzMzOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PGc+PGc+PHBhdGggZD0iTTExNC44MjMsMjc3LjMzM2MtNDEuODEzLDAtNzIuMTU2LDMxLjQwMy03Mi4xNTYsNzQuNjU5YzAsNDYuMDY4LTQwLjEwNCw5OS42ODctNDAuNTEsMTAwLjIxOCBjLTIuNDA2LDMuMTg3LTIuODMzLDcuNDQ3LTEuMTA0LDExLjA0YzEuNzE5LDMuNjA0LDUuMzAyLDUuOTM3LDkuMjkyLDYuMDYyYzAuMTA0LDAsMS45NTgsMC4wMjEsMi4wNjMsMC4wMjEgYzcuNDksMCwzNS4xMDQtMC43MDgsNzYuMTg4LTkuNzE4QzE0NS42MTQsNDQ3LjEwNywxOTIsMzk5Ljg5MywxOTIsMzU0LjM3N0MxOTIsMzExLjg5MiwxNTcuMzc1LDI3Ny4zMzMsMTE0LjgyMywyNzcuMzMzeiI+PC9wYXRoPjxwYXRoIGQ9Ik0yMDQuNSwyMTkuNTgzYy00LjE2Ny00LjE2Ny0xMC45MTctNC4xNjctMTUuMDgzLDBsLTMxLjMzMywzMS4zMjNjLTIuMzk2LDIuMzg1LTMuNTEsNS43NzEtMy4wMSw5LjEyNSBjMC41LDMuMzQ0LDIuNTYzLDYuMjUsNS41NTIsNy44NDRjMTcuNDU4LDkuMjYsMzEuNTgzLDIzLjM3NSw0MC44NTQsNDAuODEzYzEuNTgzLDIuOTksNC40OSw1LjA1Miw3LjgzMyw1LjU1MiBjMC41MzEsMC4wNzMsMS4wNjMsMC4xMTUsMS41ODMsMC4xMTVjMi44MTMsMCw1LjUzMS0xLjEwNCw3LjU0Mi0zLjEyNWwzMS4zMTMtMzEuMzEzYzQuMTY3LTQuMTY3LDQuMTY3LTEwLjkxNywwLTE1LjA4MyBMMjA0LjUsMjE5LjU4M3oiPjwvcGF0aD48cGF0aCBkPSJNNDI2LjY2NywwYy0xMS4zOTYsMC0yMi4xMDQsNC40MzgtMzAuMTY3LDEyLjVMMjE5LjU4MywxODkuNDE3Yy0yLDItMy4xMjUsNC43MDgtMy4xMjUsNy41NDIgYzAsMi44MzMsMS4xMjUsNS41NDIsMy4xMjUsNy41NDJsNDUuMjUsNDUuMjVjMiwyLDQuNzA4LDMuMTI1LDcuNTQyLDMuMTI1YzIuODMzLDAsNS41NDItMS4xMjUsNy41NDItMy4xMjVMNDU2LjgzMyw3Mi44MzMgYzguMDYzLTguMDYzLDEyLjUtMTguNzcxLDEyLjUtMzAuMTY3QzQ2OS4zMzMsMTkuMTM1LDQ1MC4xOTgsMCw0MjYuNjY3LDB6Ij48L3BhdGg+PC9nPjwvZz48L2c+PC9zdmc+);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
  }

  .button-dev--off::after {
    opacity: 0.3;
  }
`;
document.head.appendChild(style);